<template>
  <nav v-if="items.length > 1" class="breadcrumbs" aria-label="Breadcrumb">
    <ol class="breadcrumbs-list">
      <li v-for="(item, idx) in items" :key="idx" class="breadcrumb-item">
        <IconRenderer
          v-if="idx > 0"
          icon="chevron-forward"
          size="small"
          class="breadcrumb-separator"
        />
        <button v-if="!item.active" class="breadcrumb-link" @click="$emit('navigate', item, idx)">
          {{ item.label }}
        </button>
        <span v-else class="breadcrumb-current" aria-current="page">
          {{ item.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import IconRenderer from '@/common/components/ui/icon/IconRenderer.vue';

export interface BreadcrumbItem {
  label: string;
  active?: boolean;
  [key: string]: unknown;
}

defineProps<{
  items: BreadcrumbItem[];
}>();

defineEmits<{
  navigate: [item: BreadcrumbItem, index: number];
}>();
</script>

<style scoped>
.breadcrumbs-list {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: var(--ion-space-2);
  flex-wrap: wrap;
  background-color: var(--ion-background-layout);
  padding-bottom: 14px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: var(--ion-space-2, 4px);
}

.breadcrumb-separator {
  color: var(--ion-color-medium, #92949c);
}

.breadcrumb-link {
  background: none;
  border: none;
  padding: 8px 12px;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--ion-color-primary, #3880ff);
  cursor: pointer;
  border-radius: var(--ion-radius-lg, 4px);
  transition: background-color 0.2s;
}

.breadcrumb-link:hover {
  /* background-color: var(--ion-color-primary, rgba(56, 128, 255, 0.1)); */
  text-decoration: underline;
  color: var(--ion-color-primary-tint);
}

.breadcrumb-current {
  padding: 4px 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--ion-text-color, #000);
}
</style>
